<template>
    <div class="ui-content dashboard">
        <div class="institute-drop">
            <div class="past-test-dropdown" v-if="students.length > 1 && isParent">
                <v-select
                    @change="updateSelectedStudent"
                    :items="students"
                    v-model="selectedStudent"
                    hide-details
                ></v-select>
            </div>
        </div>

        <div class="page-user user leaderboard-tab" v-if="subjects.length > 0">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                    v-for="(subject, idx) in subjects"
                    :key="idx"
                    :href="'#'+idx"
                    @click="tabClicked = !tabClicked"
                >{{subject.name}}</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item v-for="(subject, idx) in subjects" :key="idx" :value="''+idx">
                        <v-card
                            class="mx-auto normal-card SubjectLeaderboard"
                            v-if="selectedSubject.id && subject.id == selectedSubject.id"
                        >
                            <SubjectLeaderboard
                                :selectedSubject="selectedSubject"
                                :studentId="studentId"
                                :tabClicked="tabClicked"
                            />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import SubjectLeaderboard from "@/components/student/SubjectLeaderboard/SubjectLeaderboard.vue";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "Leaderboard",
    components: {
        SubjectLeaderboard
    },
    mounted() {
        if (this.user.role_id == this.roleIds.PA) {
            this.initStudentData();
        } else {
            this.studentId = this.user.id;
            this.getSubjectsBatchWise();
        }
    },
    computed: {
        ...mapState("userStore", ["user"])
    },

    data() {
        return {
            tabClicked: false,
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tab: null,
            students: [],
            selectedStudent: {},
            studentId: null,
            isParent: false,
            subjects: [],
            selectedSubject: {},
            chapters: []
        };
    },
    methods: {
        ...mapActions({
            getLeaderBoardData: "healthStore/getLeaderBoardData",
            getSubjectBatchWise: "resultStore/getSubjectBatchWise"
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd) {
                this.tab = crd.hasOwnProperty('selectedTab') ? crd.selectedTab : 0;
            }
        },        
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            let tabDetails = {};
            this.subjects.forEach((s, idx) => {
                let details = {selectedChapter: null}
                tabDetails[idx] = details;
            })
            
            if(rp.params.resetPage || !crd.routeName) {            
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    selectedStudent: this.selectedStudent,
                    tabDetails: tabDetails
                }
                this.setRouteDetails(routeDetails);
            }
            this.updateSelectedSubject(this.subjects[this.tab]);
        },
        updateSelectedStudent() {
            this.studentId = this.selectedStudent.id;
            let routeName = this.$rotue.name;
            let crd = this.getCurrentRouteDetails(routeName);
            crd.selectedStudent = this.selectedStudent;
            this.setRouteDetails(crd);
            this.getSubjectsBatchWise();
        },
        initStudentData() {
            this.isParent = true;
            this.students = this.user.students.map(student => {
                let studentObj = {
                    text: student.name,
                    value: {
                        id: student.id,
                        batchId: student.batch_id
                    }
                };
                return studentObj;
            });
            this.selectedStudent = this.students[0].value;
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            this.selectedStudent = crd && crd.selectedStudent ? crd.selectedStudent : this.students[0].value;
            this.studentId = this.selectedStudent.id;
            this.getSubjectsBatchWise();
        },
        getColor(percentage) {
            let color = "";
            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        },
        getSubjectsBatchWise() {
            this.subjects = [];
            let batch_id = this.user.batch_id;
             
            if (this.isParent) {
                batch_id = this.selectedStudent.batchId;
            } else {
                this.selectedStudent = {
                    id: this.studentId,
                    batchId: this.user.batch_id
                }
            }
            let reqData = { batch_id, chapters: true };
            this.$root.showLoader = true;
            this.getSubjectBatchWise(reqData)
                .then(response => {
                    this.subjects = response.map((s, idx) => {
                        let chapters = s.children.map(chapter => {
                            return {
                                name: chapter.title,
                                id: chapter.id
                            };
                        });
                        return {
                            name: s.title,
                            id: s.id,
                            chapters
                        };
                    });
                    this.defaultData();
                    this.checkSessionData();
                    // this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        updateSelectedSubject(subject) {
            this.selectedSubject = subject;
        }
    },
    watch: {
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({routeName, selectedTab: val});
                this.updateSelectedSubject(this.subjects[val]); 
            }
        }
    }
};
</script>